import { ResultModel } from '../models/result.model'
import { EditMilestoneDateModel } from '../shared/models/service-models/EditMilestoneDate.model'
import {
  EditMilestoneDateResultModel,
  EditMilestoneStartDateResultModel,
} from '../shared/models/service-models/EditMilestoneDateResult.model'
import { EditMilestoneStartDateModel } from '../shared/models/service-models/EditMilestoneStartDate.model'
import { GetEditMilestoneStartDateECDAdjustmentsModel } from '../shared/models/service-models/GetEditMilestoneStartDateECDAdjustments.model'
import { GetEditMilestoneStartDateECDAdjustmentsResultModel } from '../shared/models/service-models/GetEditMilestoneStartDateECDAdjustmentsResult.model'
import RequestFactory from './RequestFactory'

const GMAE2EURL = process.env.REACT_APP_GMAE2E_URL

const MilestoneDateService = {
  getMilestoneMinimumDate: async (e2eProjectLineMilestoneId: string, isStartDate: boolean) =>
    (await RequestFactory.post(
      GMAE2EURL,
      `/api/milestone-date/get-milestone-minimum-date?e2eProjectLineMilestoneId=${e2eProjectLineMilestoneId}&isStartDate=${isStartDate}`
    )) as Promise<ResultModel<Date | null>>,

  editDate: async (model: EditMilestoneDateModel) =>
    (await RequestFactory.post(GMAE2EURL, `/api/milestone-date/edit-date`, model)) as Promise<
      ResultModel<EditMilestoneDateResultModel>
    >,

  getEditMilestoneStartDateECDAdjustments: async (
    model: GetEditMilestoneStartDateECDAdjustmentsModel
  ) =>
    (await RequestFactory.post(
      GMAE2EURL,
      `/api/milestone-date/get-edit-milestone-start-date-ecd-adjustments`,
      model
    )) as Promise<ResultModel<GetEditMilestoneStartDateECDAdjustmentsResultModel>>,
  getMilestoneMinimumStartDate: async (e2eProjectLineMilestoneId: string) =>
    (await RequestFactory.get(
      GMAE2EURL,
      `/api/milestone-date/get-milestone-minimum-start-date?e2eProjectLineMilestoneId=${e2eProjectLineMilestoneId}`
    )) as Promise<ResultModel<string>>,
  editMilestoneStartDate: async (model: EditMilestoneStartDateModel) =>
    (await RequestFactory.post(
      GMAE2EURL,
      `/api/milestone-date/edit-milestone-start-date`,
      model
    )) as Promise<ResultModel<EditMilestoneStartDateResultModel>>,
}

export default MilestoneDateService
